import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'usuarios/funciones/';

/**
 * GET Funciones
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getFunciones = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Función
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getFuncion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Función
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postFuncion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Función
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchFuncion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Función
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteFuncion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
